import { Hubs } from 'utils/gloo-types';
import { getVideoThumbnail, isVideo } from 'utils/discover';
import PlayVideoButton from 'components/molecules/PlayVideoButton';

interface HubImageContentProps {
  hub: Hubs;
  title?: string;
  imageUrl: string;
  linkUrl?: string;
}

const HubImageContent = ({ hub, title, imageUrl, linkUrl }: HubImageContentProps) => {
  const hasVideoContent = isVideo(imageUrl);
  const thumbnailImageUrl = hasVideoContent ? getVideoThumbnail(imageUrl) : imageUrl;
  const imageComponent = <img src={thumbnailImageUrl} alt={title ?? hub.title} />;
  return (
    <div className="relative">
      {hasVideoContent ? (
        <>
          {imageComponent}
          <PlayVideoButton imageUrl={imageUrl} />
        </>
      ) : linkUrl ? (
        <a target="_blank" href={linkUrl} rel="noreferrer" data-durable-id={linkUrl} data-intercom-target={linkUrl}>
          {imageComponent}
        </a>
      ) : (
        imageComponent
      )}
    </div>
  );
};

export default HubImageContent;
